export default __webpack_public_path__ + "static/media/P.dd5040fa.wav";